import { _ as r } from "../internals/export.js";
import { d as e } from "../internals/descriptors.js";
import "../internals/object-define-property.js";
import { __exports as t } from "../../../_virtual/object-define-property.js";
var o = t.f;
r({
  target: "Object",
  stat: !0,
  forced: Object.defineProperty !== o,
  sham: !e
}, {
  defineProperty: o
});